import { render } from "./ThemHoiNghi.vue?vue&type=template&id=5b346758&scoped=true&ts=true"
import script from "./ThemHoiNghi.vue?vue&type=script&lang=ts"
export * from "./ThemHoiNghi.vue?vue&type=script&lang=ts"

import "./ThemHoiNghi.vue?vue&type=style&index=0&id=5b346758&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b346758"]])

export default __exports__